/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { useState } from 'react';
import Popover from '@mui/material/Popover';
import DropdownItem from '../DropdownItem';
import { Colors } from 'styles/variables/colors';
import * as S from '../../Dashboard.styled';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

type SelectRetainerTypeDropdownProps = {
    selectedType: string;
    mobile?: boolean;
    handleSelectedType: (selectedType: string) => void;
    dropdownMenuPrograms: any;
    clientProfile?: boolean;
    customStyleForSearchbar?: boolean;
    agreementPage?: boolean;
    dashboard?: boolean;
    onboarding?: boolean;
    width?: string;
};

const SelectRetainerTypeDropdown = ({
    selectedType,
    mobile,
    handleSelectedType,
    dropdownMenuPrograms,
    clientProfile,
    customStyleForSearchbar,
    agreementPage,
    dashboard,
    onboarding,
    width,
}: SelectRetainerTypeDropdownProps) => {
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleOptionClick = (e: React.MouseEvent<HTMLElement>, selectedType: any) => {
        e.stopPropagation();
        handleSelectedType(selectedType.name);
        handleClose();
    };

    // useEffect(() => {
    //     handleSelectedType(t('selectType', { lng: language }));
    // }, []);

    return (
        <>
            <S.LeftDropdown
                id="retainer-dropdown"
                onboarding={onboarding}
                dashboard={dashboard}
                customStyleForSearchbar={customStyleForSearchbar}
                clientProfile={clientProfile}
                mobile={mobile}
                agreementPage={agreementPage}
                isActive={!!anchorEl}
                onClick={(event) => {
                    handleClick(event);
                }}
                width={width}
            >
                <S.SelectionContainer
                    style={{
                        color:
                            selectedType === t('selectRetainerType', { lng: language }) ||
                            selectedType === t('selectType', { lng: language })
                                ? Colors.red
                                : Colors.black,
                        fontWeight: 500,
                    }}
                >
                    {selectedType}
                </S.SelectionContainer>

                <S.DropdownIcon />
            </S.LeftDropdown>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                marginThreshold={0}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                slotProps={{
                    paper: {
                        sx: {
                            overflow: 'visible',
                            mt: '8px',
                            minWidth: '7rem',
                            padding: '0',
                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.09)',
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            >
                <S.DropDownMenu>
                    {dropdownMenuPrograms &&
                        dropdownMenuPrograms.map((option: any, i: number) => {
                            return (
                                <DropdownItem
                                    style={{ display: 'inline-block' }}
                                    key={i}
                                    onClick={(e) => handleOptionClick(e, option)}
                                >
                                    {option.name}
                                </DropdownItem>
                            );
                        })}
                </S.DropDownMenu>
            </Popover>
        </>
    );
};

export default SelectRetainerTypeDropdown;
